/* auralis · home v4.3 (25-sep-2026) — selector «cuál es para mí» (si vuelve a activarse), pausa de videos, videos solo cuando se ven, scroll de reseñas con flechas, zoom de fotos antes/después. Hero 25-sep: el video ahora es un link, el botón de pausa lleva preventDefault/stopPropagation en su propio onclick (en el liquid), este handler ya no navega. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideos(root) {
    var vids = [].slice.call(root.querySelectorAll('video[data-ah]'));
    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      var btn = v.parentNode.querySelector('.pz');
      var paused = reduce;
      function sync() { if (btn) btn.setAttribute('aria-pressed', paused ? 'true' : 'false'); if (btn) btn.setAttribute('aria-label', paused ? 'Reproducir video' : 'Pausar video'); }
      function play() { if (!paused && v.offsetParent !== null) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      if (btn) btn.addEventListener('click', function (e) { if (e) { e.preventDefault(); e.stopPropagation(); } paused = !paused; paused ? v.pause() : play(); sync(); });
      sync();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) {
              if (!v.getAttribute('src') && v.dataset.src) { v.setAttribute('src', v.dataset.src); }
              play();
            } else { v.pause(); }
          });
        }, { rootMargin: '200px 0px' }).observe(v);
      } else {
        if (v.dataset.src) v.setAttribute('src', v.dataset.src);
        play();
      }
    });
  }

  function initSelector(root) {
    var q = root.querySelector('[data-ah-selector]');
    if (!q || q.dataset.ready) return;
    q.dataset.ready = '1';
    var btns = [].slice.call(q.querySelectorAll('[data-pick]'));
    var out = q.querySelector('.out');
    var hint = out.querySelector('.hint');
    var res = out.querySelector('.res');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var d = b.dataset;
        res.querySelector('.eb').textContent = 'la tuya es ' + d.name;
        res.querySelector('.why').textContent = d.why;
        res.querySelector('.pr').textContent = d.price;
        var a = res.querySelector('.pill');
        a.setAttribute('href', d.href);
        a.textContent = d.cta;
        hint.hidden = true;
        res.hidden = false;
        if (window.dataLayer) window.dataLayer.push({ event: 'auralis_selector', hair_goal: d.key });
      });
    });
  }

  function scrollQuotes(dir) {
    var track = document.getElementById('qTrack');
    if (!track) return;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  }
  window.auralisScrollQuotes = scrollQuotes;

  function zoomStrip(btn) {
    var img = btn.closest('.ah-strip') && btn.closest('.ah-strip').querySelector('img');
    if (!img) return;
    var ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(20,20,18,.92);z-index:99;display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
    var big = document.createElement('img');
    big.src = img.currentSrc || img.src;
    big.alt = img.alt;
    big.style.cssText = 'max-width:100%;max-height:100%;border-radius:8px';
    ov.appendChild(big);
    ov.addEventListener('click', function () { ov.remove(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { ov.remove(); document.removeEventListener('keydown', esc); } });
    document.body.appendChild(ov);
  }
  window.auralisZoomStrip = zoomStrip;

  function goCual(smooth) {
    var t = document.getElementById('cual');
    if (t) t.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }
  if (location.hash === '#cual') {
    window.addEventListener('load', function () { setTimeout(function () { goCual(false); }, 120); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#cual"]');
    if (!a || !document.getElementById('cual')) return;
    var u = new URL(a.getAttribute('href'), location.href);
    if (u.pathname !== location.pathname) return;
    e.preventDefault();
    var burger = document.querySelector('.mobile-menu__button--burger[aria-expanded="true"]');
    var close = document.querySelector('.drawer__close-button');
    if (burger && close) close.click();
    setTimeout(function () { goCual(true); }, burger ? 350 : 0);
    if (history.replaceState) history.replaceState(null, '', '#cual');
  });

  function init(root) { initVideos(root || document); initSelector(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
